<template>
  <div v-if="storedCustomer && apiUser && apiUser.isCustomerAdmin" class="admin-page__content">
    <form>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h2 class="mb-0">
            {{ $t("spravaNotifikaci") }}
          </h2>
          {{ $t("proZakaznika") }} {{ storedCustomer.customerName }}
        </div>
        <!--
        <div
          class="btn btn-primary d-flex align-items-center justify-content-center"
          @click="toggleNewUser('newUser')"
        >
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-nova.svg" />
          </div>
          {{ $t("novyUzivatel") }}
        </div>
        -->
      </div>
    </form>

    <div class="mt-4">
      <RadioHelp
        :article-link="'/admin/customer/notifications'"
        :show="showHelp"
        @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
        @update-show-radio-help="showRadioHelp($event)"
      />
      <div class="d-flex flex-wrap mt-3 mb-2 position-relative">
        <!--
                <div class="d-flex">
                  <span class="btn-sm d-flex align-items-center justify-content-center"
                    >{{ $t("Správa osob") }}:</span
                  >
                  <a
                    class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center mr-2"
                    target="_blank"
                    v-bind:href="this.$t('LINK_MOJE_CRA')"
                  >
                    {{ $t("Moje CRA") }}
                  </a>
                </div>
                -->

        <!--button
                  v-if="selectedRows"
                  class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                  :disabled="selectedRows.length == 0"
                  @click="toggleDeleteUsers(selectedRows)"
                >
                  {{ $t("smazatUzivatele") }}
                </button-->
        <RadioOpenClose
          :custom-class="'d-flex align-items-end radio--default'"
          :radio-slides="radioSlides"
          :show="showHelp"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="usersWithProjects.length > 0" class="position-relative w-100">
        <div id="usersNotifications" class="table-responsive">
          <table class="table table-main table-hover">
            <thead>
              <tr>
                <th
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="{ isHidden: !column.visible }"
                  :style="{ 'min-width': column.minWidth }"
                >
                  <span v-if="column.sortable != true">
                    {{ $t(column.name) }}
                  </span>
                  <span v-else>
                    <div class="title" @click="sortBy(column.sortBy)">
                      {{ $t(column.name) }}
                    </div>
                    <div v-if="sort == column.type" class="sorting">
                      <span v-if="sortType == 'desc'">▼</span>
                      <span v-if="sortType == 'asc'">▲</span>
                    </div>
                  </span>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in usersWithProjects.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td
                  v-for="(column, column_index) in columns"
                  :key="column_index"
                  :class="{
                    isHidden: !column.visible,
                    'notifications-on': column.name == 'notificationsOn'
                  }"
                  :style="{ width: column.minWidth }"
                >
                  <span v-if="column.name == 'email'">
                    <a @click="openEditNotifications(item)">
                      {{ item[column.type] }}
                    </a>
                  </span>
                  <span
                    v-else-if="column.name == 'notificationsOn' && item[column.type] == 'zapnuto'"
                    class="notificationsOn"
                  >
                    {{ item[column.type] }}
                  </span>
                  <span v-else>
                    {{ item[column.type] }}
                  </span>
                </td>
                <td />
              </tr>
            </tbody>
          </table>
          <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
            <thead>
              <tr>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in usersWithProjects.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td>
                  <div
                    id="kebab"
                    ref="kebab"
                    :class="{
                      opened: openedItem.email == item.email
                    }"
                    class="kebab"
                  >
                    <div class="dropdown-actions">
                      <div class="atom-icon d-block mr-0" @click="openKebab(item)">
                        <img src="@/assets/icons/menu/ico-kebab.svg" />
                      </div>
                      <div
                        v-if="openedItem.email == item.email"
                        v-click-outside="closeKebabConf"
                        class="dropdown-actions__wrapper"
                      >
                        <div class="dropdown-actions__inner">
                          <div
                            class="dropdown-actions__item d-flex align-items-center"
                            @click="openEditNotifications(openedItem)"
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/admin/ico-ico-zakaznik.svg" />
                            </div>

                            {{ $t("upravit") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="usersWithProjects.length > 0"
        class="custom-table__footer d-flex align-items-center justify-content-between"
      >
        <div class="custom-table__footer__actions align-items-center" />

        <Paging
          :page="{
            currentPage: page,
            rowsPerPage: rowsPerPage,
            itemsTotalCount: usersWithProjects.length,
            itemsCount: usersWithProjects.length
          }"
          @next-page="page++"
          @page="page = $event"
          @prev-page="page--"
          @rows-per-page="rowsPerPage = $event"
        />
      </div>
      <div v-else>
        <Loader />
      </div>
    </div>
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
    <EditNotificationsModal
      v-if="this.actionItem"
      :item="this.actionItem"
      :notification="this.actionItem"
      :opened="openedEditNotificationsModal"
      @close-box="toggleEditNotificationsModal"
      @open-box="toggleEditNotificationsModal"
      @reload="reloadUser"
    />
  </div>
  <div v-else>
    {{ $t("nemateOpravneniProhlizetTutoStranku") }}
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import EditNotificationsModal from "@/components/modals/notifications/edit.vue"
import Paging from "@/components/paging/paging.vue"
import Loader from "@/components/loader.vue"
import { useAuthStore } from "@/store/modules/auth"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    Paging,
    RadioHelp,
    RadioOpenClose,
    ErrorModal,
    Loader,
    EditNotificationsModal
  },
  setup() {
    const authStore = useAuthStore()
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()
    const configStore = useConfigStore()

    return { authStore, customerStore, projectStore, configStore }
  },
  data() {
    return {
      showShadow: false,
      radioSlides: [],
      showHelp: true,
      users: [],
      loading: false,
      openedItem: {},
      selectedRows: [],
      openedDetail: [],
      openedEditDetail: [],
      selectedUser: {},
      openedAppend: [],
      openedRemove: [],
      customerUsers: [],
      openedNewUser: [],
      openedEditNotificationsModal: [],
      usersWithProjects: [],
      openedDeleteUser: false,
      deleteText: "",
      errorsToTranslate: [],
      openedError: false,
      showModalDeleteSingleUser: false,
      modalOpenedDeleteUser: false,
      usersToDelete: [],
      actionItem: {},
      notifications: [],
      sort: "email",
      sortType: "asc",
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      rowsPerPage: 20,
      isActionsDropdownVisible: false,
      page: 0,
      tableColumns: {},
      columns: [
        {
          type: "email",
          name: "email",
          sortable: true,
          visible: true,
          minWidth: "250px",
          sortBy: "email",
          order: 1
        },
        {
          type: "firstName",
          name: "firstName",
          sortable: true,
          visible: true,
          order: 2,
          sortBy: "firstName",
          minWidth: "50px"
        },
        {
          type: "lastName",
          name: "lastName",
          sortable: true,
          visible: true,
          order: 3,
          minWidth: "50px",
          sortBy: "lastName"
        },
        {
          type: "notificationsOn",
          name: "notificationsOn",
          sortable: true,
          visible: true,
          order: 4,
          minWidth: "100px",
          sortBy: "notificationsOn"
        },
        {
          type: "notificationsLanguage",
          name: "notificationsLanguage",
          sortable: true,
          visible: true,
          order: 5,
          minWidth: "20px",
          sortBy: "notificationsLanguage"
        }
      ],
      tableColumnsDefault: {
        email: {
          show: true,
          order: 1,
          title: "email"
        },
        firstName: {
          show: true,
          order: 2,
          title: "firstName"
        },
        lastName: {
          show: true,
          order: 3,
          title: "lastName"
        },
        notificationsOn: {
          show: true,
          order: 4,
          title: "notificationsOn"
        },
        notificationsLanguage: {
          show: true,
          order: 5,
          title: "notificationsLanguage"
        }
      }
    }
  },
  computed: {
    apiUser() {
      return this.authStore.apiUser
    },
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    projects() {
      return this.projectStore.projectList
    },
    customer() {
      return this.customerStore.selectedCustomer
    },
    customersProjects() {
      if (this.projects.filter((p) => p.customerId === this.customer.customerId).length > 0) {
        return this.projects.filter((p) => p.customerId === this.customer.customerId)
      } else {
        return []
      }
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    storedCustomer() {
      this.loadUsers()
    },
    async customerUsers() {
      await this.loadUsersWithProjects()
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    },
    apiUser() {
      //this.loadNotifications();
    }
  },
  async mounted() {
    this.showHelp = !this.radioDisabled
    if (this.storedCustomer) {
      this.loadUsers()
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })
  },
  methods: {
    sortBy(sortBy) {
      let sorted
      this.isSelectedAllOnPage = false
      this.sort = sortBy
      if (this.sortType == "asc") {
        sorted = _.orderBy(this.usersWithProjects, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.usersWithProjects, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.usersWithProjects = sorted
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    middlewareKebab(event) {
      return event.target.className !== "custom-control-label"
    },
    openKebab(user) {
      this.openedItem = this.openedItem == user ? {} : user
    },
    closeKebab() {
      this.openedItem = {}
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "usersNotifications")
    },
    reloadUser(event) {
      let notificationState = event.enabled ? this.$t("zapnuto") : this.$t("vypnuto")

      this.usersWithProjects = this.usersWithProjects.map((i) => {
        if (i.email === event.email) {
          i.notificationsOn = notificationState
          i.customRowClass = event.enabled ? "notifications-on" : ""
          return i
        }
        return i
      })
    },
    getNotificationsForEmail(email) {
      let notifications = {}
      if (this.notifications[email] === undefined) {
        notifications = {
          customer: this.customer,
          email: email,
          language: "CZ",
          isCustomerAdmin: true,
          enabled: false,
          notifications: {},
          register: true
        }
      } else {
        notifications = this.notifications[email]
      }

      return notifications
    },
    openItem(item) {
      this.openedItem = item
      console.log(item, "OPENED")
    },
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    async loadNotifications() {
      let promises = []
      let apiUser = await this.apiUser
      let notifications = []
      if (apiUser) {
        promises.push(
          axios
            .get(
              process.env.VUE_APP_API + "/notifications?customerId[eq]=" + this.customer.customerId + "&limit=1000",
              {}
            )
            .then((result) => {
              result.data.data.forEach((notification) => {
                notifications[notification.email] = {
                  customer: this.customer,
                  email: notification.email,
                  enabled: true,
                  language: notification.notifications[0].language,
                  isCustomerAdmin: true,
                  notifications: notification.notifications,
                  register: true
                }
              })
              this.notifications = notifications
              this.loaded = true
              this.$store.commit("modals/setWaitingLoader", "")
            })
            .catch(() => {
              this.$store.commit("modals/setWaitingLoader", "")
            })
        )

        return Promise.all(promises).then(() => {
          this.$nextTick(() => {
            this.updateResponsiveTable()
          })
          return true
        })
      }
    },
    loadUsers() {
      this.customerUsers = []
      this.users = []
      this.errorsToTranslate = []

      axios
        .get(process.env.VUE_APP_API + "/users?limit=1&customerId[eq]=" + this.storedCustomer.customerId)
        .then((result) => {
          let query
          let steps = Math.ceil(result.data.metadata.count / 200)
          let promises = []
          for (let i = 0; i < steps; i++) {
            query = "/users?customerId[eq]=" + this.storedCustomer.customerId + "&offset=" + i * 200 + "&limit=200"

            promises.push(
              axios
                .get(process.env.VUE_APP_API + query)
                .then((result) => {
                  this.users = result.data.data
                  // customerAdmin has all projects, we have to disable checkbox in table
                  result.data.data.forEach((user) => {
                    let isIotAdmin = false
                    /**
                     * let's find whether user is IoTAdmin
                     */
                    user.privileges.forEach((privilege) => {
                      if (privilege.privilege == "IoTAdmin" && privilege.customerId == this.storedCustomer.customerId) {
                        isIotAdmin = true
                      }
                    })
                    if (
                      user.privileges.some(
                        ({ privilege, customerId }) =>
                          privilege === "CustomerAdmin" && customerId == this.storedCustomer.customerId
                      )
                    ) {
                      user.notSelectable = true
                    }
                    /**
                     * IoTAdmins are not shown in table
                     */
                    if (isIotAdmin === false) {
                      this.customerUsers = this.customerUsers.concat([user])
                    }
                  })
                })
                .catch((error) => {
                  if (error.status) {
                    let err = []
                    err.errors = []
                    err.errors.push({
                      message: error.status + " " + error.statusText
                    })
                    this.errorsToTranslate.push(err)
                    if (this.errorsToTranslate.length > 0) {
                      this.openedError = true
                    }
                  }
                })
            )
          }
          return Promise.all(promises).then(() => {
            this.$nextTick(() => {
              this.updateResponsiveTable()
            })
            return true
          })
        })
    },
    async loadUsersWithProjects() {
      this.loading = true
      await this.loadNotifications()
      let users = []
      this.customerUsers.forEach((user) => {
        let obj = Object.assign(user)
        if (this.notifications[obj.email] !== undefined) {
          obj.notificationsOn = this.$t("zapnuto")
          obj.customRowClass = "notifications-on"
          obj.notificationsLanguage = this.notifications[obj.email].language
        } else {
          obj.notificationsOn = this.$t("vypnuto")
          obj.notificationsLanguage = "CZ"
        }

        users.push(obj)
        this.loading = false
      })
      this.$store.commit("modals/setWaitingLoader", "")
      this.usersWithProjects = users
      this.$nextTick(() => {
        this.updateResponsiveTable()
      })
    },
    toggleEditNotificationsModal(box) {
      if (this.openedEditNotificationsModal.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditNotificationsModal = [])
          : this.openedEditNotificationsModal.splice(this.openedEditNotificationsModal.indexOf(box), 1)
      } else {
        this.openedEditNotificationsModal.push(box)
      }
    },
    openEditNotifications(item) {
      this.actionItem = this.getNotificationsForEmail(item.email)
      this.toggleEditNotificationsModal("editNotifications")
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>

<style lang="scss" scoped></style>
